/** Soft UX cooldown for invite resend (no server rate-limit policy). */
export const INVITE_RESEND_COOLDOWN_MS = 60_000;

export const getInviteResendCooldownRemainingMs = (
  invitedAt: string | null | undefined,
  nowMs: number = Date.now()
): number => {
  if (!invitedAt) {
    return 0;
  }

  const sentAt = new Date(invitedAt).getTime();
  if (Number.isNaN(sentAt)) {
    return 0;
  }

  return Math.max(0, sentAt + INVITE_RESEND_COOLDOWN_MS - nowMs);
};

export const formatInviteCooldownSeconds = (remainingMs: number): number =>
  Math.ceil(remainingMs / 1000);
